import React from "react";
import GitHubCalendar from "react-github-calendar";
import { Row } from "react-bootstrap";

function Github() {
  return (
    <>
       <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
      <h1 className="text-center font-details-b pb-4">DAYS I CODE</h1>
      
      <GitHubCalendar
        username="samratb963"
        blockSize={15}
        blockMargin={5}
        color="green"
        fontSize={16}
        background = "black"
      />
    </Row>
    <img className = "statsimg" style={{ display: "flex", justifyContent: "center",  color: "white",marginBottom:"40px", height: "200px", alignItems: "center", width: "88%", margin: "auto" }} src="https://camo.githubusercontent.com/9876e6dc6a478a1d10b9e36521ddfe8c87672dd81f2958fcba3ec63c6a278d5d/68747470733a2f2f6769746875622d726561646d652d73747265616b2d73746174732e6865726f6b756170702e636f6d2f3f757365723d53616d72617442393633267468656d653d7261646963616c26636f756e745f707269766174653d74727565" />
    <br />
    <br />
    </>
 
  );
}

export default Github;